import { FieldValidation } from '../../core/domain/transaction/fieldValidation';

export const required: FieldValidation = (value) => !!value;
